module.exports = __webpack_public_path__ + "static/media/Matlandia6_przewodnik_po_zadaniach.5a9e6404.pdf";